import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpleToggle } from "../../_components";
import ToolTipWrapper from "../../_components/ToolTipWrapper";

type CreatePublicUrlToggleType = {
    initialState?: boolean;
    onChange: (value: boolean) => void;
    boldedName?: boolean;
    readOnly?: boolean;
    // Only for PMS that deliver the link themselves (Hostify, Kross, Avaibook):
    // there, this send is an extra. Where it is the only delivery, leave it off.
    optional?: boolean;
    // Override the wording. The default says "email or SMS", which is true of
    // the PMS-synced path (it falls back to SMS when the PMS gives no email but
    // does give a phone) but not of every caller.
    label?: string;
    tooltip?: string;
};

export default function SendInvitationURLToggle({
    onChange,
    initialState,
    boldedName = true,
    readOnly = false,
    optional = false,
    label,
    tooltip,
}: CreatePublicUrlToggleType) {

    const [state, setState] = useState(initialState);
    const { t } = useTranslation();

    useEffect(() => setState(initialState), [initialState])

    return (
        <div className={`${readOnly ? 'cna' : ''} d-flex align-items-center justify-content-between`}>
            <ToolTipWrapper tooltip={tooltip ?? t("invitation_public_url_send_action_tooltip")}>
                <div className={`${boldedName ? 'font-weight-bold' : ''} position-relative`}>
                    {label ?? t("invitation_public_url_send_action")}
                    {optional && <span className="text-muted"> ({t("global_optional")})</span>}
                </div>
            </ToolTipWrapper>
            <div className="ml-2"></div>
            <SimpleToggle
                readOnly={readOnly}
                checked={state}
                handleChange={({ detail: { value } }) => {
                    setState(value);
                    onChange(value);
                }}
            ></SimpleToggle>
        </div>
    );
}
